import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import Theme from "../../theme/theme";
import Message from "./Message";
import { PageWrapper } from "./styles/disengaged-styles";

export interface DisengagedProps {
  disengagedBy: string;
  message?: string;
}

export const Disengaged: FunctionComponent<DisengagedProps> = ({
  disengagedBy,
  message,
}) => (
  <Theme>
    <PageWrapper>
      <Message disengagedBy={disengagedBy} message={message} />
    </PageWrapper>
  </Theme>
);

Disengaged.propTypes = {
  disengagedBy: PropTypes.string.isRequired,
  message: PropTypes.string,
};

Disengaged.defaultProps = {
  message: null,
};

export default Disengaged;
